import { useForm } from "react-hook-form";

import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { Button } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useAcceptUsersChangeLogWithIdMutation } from "../../../../../user/userApiSlice";

const AcceptDialog = ({ onClose, open, changeId }) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [acceptChange, { isLoading }] = useAcceptUsersChangeLogWithIdMutation();

	const { handleSubmit, control, formState, setError } = useForm({
		// resolver: yupResolver(formSchema),
		shouldFocusError: true,
	});

	const submitNewUser = async () => {
		await acceptChange({ changeId })
			.unwrap()
			.then((_payload) => {
				enqueueSnackbar(t("accepted_change"), {
					variant: "success",
					preventDuplicate: true,
				});
				onClose();
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([key, message]) => {
						setError(key);
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	return (
		<Dialog fullWidth maxWidth="sm" onClose={onClose} open={open}>
			<Box sx={{ padding: "30px" }}>
				<Box component="form" onSubmit={handleSubmit(submitNewUser)}>
					<Grid container rowSpacing={3} columnSpacing={2}>
						<Grid size={12}>
							<Box sx={{ textAlign: "center" }}>
								<Typography variant="h5" component="span">
									{t("has_data_been_entered_into_record_and_updated_payments")}
								</Typography>
							</Box>
						</Grid>
						<Grid size={6}>
							<Box sx={{ display: "flex", justifyContent: "end" }}>
								<Button
									type="submit"
									loading={isLoading}
									variant="contained"
									sx={{ textTransform: "uppercase" }}
								>
									{t("yes")}
								</Button>
							</Box>
						</Grid>
						<Grid size={6}>
							<Box sx={{ display: "flex", justifyContent: "start" }}>
								<Button variant="contained" color="secondary" onClick={onClose}>
									{t("cancel")}
								</Button>
							</Box>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</Dialog>
	);
};

export default AcceptDialog;
